import Icon from '../../Icon';

export type ColorOption = {
  name: string;
  color: string | null;
};

export const LinkIcon = () => <Icon name='hero-link' className='tiptap-bubble-menu__icon' />;
export const HeadingIcon = () => <Icon name='hero-bars-3-bottom-left' className='tiptap-bubble-menu__icon' />;
export const Heading1Icon = () => <span className='tiptap-bubble-menu__icon tiptap-heading-icon'>H1</span>;
export const Heading2Icon = () => <span className='tiptap-bubble-menu__icon tiptap-heading-icon'>H2</span>;
export const Heading3Icon = () => <span className='tiptap-bubble-menu__icon tiptap-heading-icon'>H3</span>;
export const Heading4Icon = () => <span className='tiptap-bubble-menu__icon tiptap-heading-icon'>H4</span>;
export const QuoteIcon = () => <Icon name='hero-chat-bubble-left-right' className='tiptap-bubble-menu__icon' />;
export const CodeBlockIcon = () => <Icon name='hero-code-bracket-square' className='tiptap-bubble-menu__icon' />;
export const BulletListIcon = () => <Icon name='hero-list-bullet' className='tiptap-bubble-menu__icon' />;
export const OrderedListIcon = () => <Icon name='hero-numbered-list' className='tiptap-bubble-menu__icon' />;
export const BoldIcon = () => <Icon name='hero-bold' className='tiptap-bubble-menu__icon' />;
export const ItalicIcon = () => <Icon name='hero-italic' className='tiptap-bubble-menu__icon' />;
export const UnderlineIcon = () => <Icon name='hero-underline' className='tiptap-bubble-menu__icon' />;
export const StrikethroughIcon = () => <Icon name='hero-strikethrough' className='tiptap-bubble-menu__icon' />;
export const TextIcon = () => <Icon name='hero-bars-3-bottom-left' className='tiptap-bubble-menu__icon' />;
export const ClearFormattingIcon = () => <Icon name='hero-trash' className='tiptap-bubble-menu__icon' />;

export type TextAlignValue = 'left' | 'center' | 'right' | 'justify';

const TEXT_ALIGN_PATHS: Record<TextAlignValue, string> = {
  left: 'M3.75 6.75h16.5M3.75 12h10.5M3.75 17.25h16.5',
  center: 'M3.75 6.75h16.5M6.75 12h10.5M3.75 17.25h16.5',
  right: 'M3.75 6.75h16.5M9.75 12h10.5M3.75 17.25h16.5',
  justify: 'M3.75 6.75h16.5M3.75 12h16.5M3.75 17.25h16.5',
};

export const AlignIcon = ({
  align,
  className = 'tiptap-bubble-menu__icon',
}: {
  align: TextAlignValue;
  className?: string;
}) => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='1.5'
    strokeLinecap='round'
    strokeLinejoin='round'
    className={className}
    aria-hidden='true'
  >
    <path d={TEXT_ALIGN_PATHS[align]} />
  </svg>
);

export const TEXT_ALIGN_OPTIONS: { value: TextAlignValue; label: string }[] = [
  { value: 'left', label: 'Align left' },
  { value: 'center', label: 'Align center' },
  { value: 'right', label: 'Align right' },
  { value: 'justify', label: 'Justify' },
];

export const TEXT_COLOR_OPTIONS: ColorOption[] = [
  { name: 'Default', color: null },
  { name: 'Gray', color: '#6b7280' },
  { name: 'Brown', color: '#92400e' },
  { name: 'Orange', color: '#ea580c' },
  { name: 'Yellow', color: '#ca8a04' },
  { name: 'Green', color: '#16a34a' },
  { name: 'Blue', color: '#2563eb' },
  { name: 'Purple', color: '#7c3aed' },
  { name: 'Pink', color: '#db2777' },
  { name: 'Red', color: '#dc2626' },
];

export const HIGHLIGHT_COLOR_OPTIONS: ColorOption[] = [
  { name: 'Yellow', color: '#fef08a' },
  { name: 'Green', color: '#bbf7d0' },
  { name: 'Blue', color: '#bfdbfe' },
  { name: 'Purple', color: '#ddd6fe' },
  { name: 'Pink', color: '#fbcfe8' },
  { name: 'Red', color: '#fecaca' },
  { name: 'Clear', color: null },
];
